import React from "react";

export default function MSAccess_RTrim() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_RTrim</h1>
      <p>This is the MSAccess_RTrim component generated from the SQL JSON.</p>
    </div>
  );
}
